export function getAudioPlayerController(application) {
  const element = document.querySelector("[data-audio-player]");
  if (!element) return null;

  return application.getControllerForElementAndIdentifier(element, "media--audio-player");
}
